import {
    AccessSegment,
    ColumnMetadata,
    ColumnTypes,
} from "~/components/DataGrid";
import { Asset, AssetColumns } from "~/modules/assets/types";
import { Emdash } from "~/components/Punctuation";
import { ImageLoader } from "~/components/ImageLoader";
import { RWA_COIN_ICON } from "~/consts";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const INCORPORATION_COUNTRY_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: "Domicile",
    label: "Domicile",
    tooltip: CatalogReferenceDataSlugs.domicile,
    sortsOn: AssetColumns.legalStructureCountryName,
    type: ColumnTypes.string,
    width: 220,
    access: {
        view: AccessSegment.Preview,
        sort: AccessSegment.Preview,
    },
    render: (item) => {
        if (item.isAsset) {
            const asset = item as Asset;

            if (!asset.issuer || !asset.issuer?.legal_structure_country) {
                return <Emdash />;
            }

            const {
                legal_structure_country,
                legal_structure_country_icon_url,
            } = asset.issuer;

            return (
                <div className="flex items-center w-full overflow-hidden">
                    {legal_structure_country_icon_url && (
                        <ImageLoader
                            src={legal_structure_country_icon_url}
                            alt={`${legal_structure_country} Flag`}
                            className="size-5 min-w-5 rounded-full mr-1.5 shadow-sm"
                            fallbackSrc={RWA_COIN_ICON}
                            fallbackClassName="bg-white opacity-50"
                        />
                    )}
                    <div className="dg-overflow">{legal_structure_country}</div>
                </div>
            );
        }

        return <Emdash />;
    },
};
